(function () {
  var openModal = null;
  var lastFocus = null;

  // Keep fixed modals outside layout overflow/transform contexts.
  document.querySelectorAll('.team-member-modal').forEach(function (modal) {
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
  });

  function getFocusable(container) {
    return Array.prototype.slice.call(
      container.querySelectorAll(
        'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (el) {
      return !el.hasAttribute('disabled') && el.getAttribute('aria-hidden') !== 'true';
    });
  }

  function openTeamModal(modal) {
    if (!modal || openModal === modal) {
      return;
    }

    if (openModal) {
      closeTeamModal(openModal, true);
    }

    lastFocus = document.activeElement;
    openModal = modal;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('team-member-modal-open');

    var dialog = modal.querySelector('.team-member-modal__dialog');
    window.setTimeout(function () {
      if (dialog) {
        dialog.focus();
      }
    }, 10);
  }

  function closeTeamModal(modal, skipRestoreFocus) {
    if (!modal) {
      return;
    }

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');

    if (openModal === modal) {
      openModal = null;
      document.body.classList.remove('team-member-modal-open');

      if (!skipRestoreFocus && lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
      }
      lastFocus = null;
    }
  }

  document.addEventListener('click', function (event) {
    var openTrigger = event.target.closest('[data-team-modal-open]');
    if (openTrigger) {
      var modalId = openTrigger.getAttribute('data-team-modal-open');
      var modal = modalId ? document.getElementById(modalId) : null;
      if (modal) {
        event.preventDefault();
        openTeamModal(modal);
      }
      return;
    }

    if (event.target.closest('[data-team-modal-close]')) {
      var closing = event.target.closest('.team-member-modal');
      if (closing) {
        event.preventDefault();
        closeTeamModal(closing);
      }
    }
  });

  document.addEventListener('keydown', function (event) {
    if (!openModal) {
      return;
    }

    if (event.key === 'Escape') {
      event.preventDefault();
      closeTeamModal(openModal);
      return;
    }

    if (event.key !== 'Tab') {
      return;
    }

    var dialog = openModal.querySelector('.team-member-modal__dialog');
    if (!dialog) {
      return;
    }

    var focusable = getFocusable(dialog);
    if (!focusable.length) {
      event.preventDefault();
      dialog.focus();
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
